import * as React from 'react';
import ListItem from './ListItem/ListItem';
import cn from '~modules/cn';
import './list.scss';

type ListProps = {
    containerClassName?: string;
    className?: string;
    dataTip?: string;
    headerText?: string;
    children?: React.ReactNode;
};

const List = ({ containerClassName, className, dataTip, headerText, children }: ListProps): JSX.Element => (
    <div className={containerClassName}>
        {headerText ? <ListItem className="list-header" text={headerText} Tag="div" /> : null}
        <ul className={cn('list', className)} data-tip={dataTip}>
            {children}
        </ul>
    </div>
);

export default List;
